// Core components
import { Injectable } from "@angular/core";

// Third party components

// Custom components
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EnvironmentService {
  /**
   * Class constructor
   */
  // constructor() {}

  /**
   * Get the API URL for current environment
   *
   * @since 1.0.0
   */
  getApiUrl(version: string = environment.apiVersion): string {
    let url = `${environment.apiProtocol}${environment.apiHost}/api/${version}`;
    if (environment.apiPort) {
      url = `${environment.apiProtocol}${environment.apiHost}:${environment.apiPort}/api/${version}`;
    }
    return url;
  }

  /**
   * Get the Suppliers API URL for current environment
   *
   * @since 1.0.0
   */
  getSuppliersApiUrl(): string {
    let url = `${environment.suppliersApiProtocol}${environment.suppliersApiHost}/api/${environment.suppliersApiVersion}`;
    if (environment.suppliersApiPort) {
      url = `${environment.suppliersApiProtocol}${environment.suppliersApiHost}:${environment.suppliersApiPort}/api/${environment.suppliersApiVersion}`;
    }
    return url;
  }

  /**
   * Get current env front-end host
   *
   * @since 1.0.0
   */
  getFrontEndHost(): string {
    return `${environment.frontEndHost}`;
  }

  /**
   * Get current config for cookie secure flat
   *
   * @since 1.0.0
   */
  getFrontEndCookieSecure(): boolean {
    return environment.cookieSecure;
  }
}
